export const CATEGORIES = [
  'All',
  'Electronics',
  'Furniture',
  'Clothing',
  'Vehicles',
  'Home',
  'Sports',
  'Toys',
  'Other',
];

export const CONDITIONS = ['New', 'Like new', 'Good', 'Fair'];

export const PICKUP_METHODS = [
  'Door pickup',
  'Public parking lot',
  'Meet in a public place',
  'Curbside',
  'Building lobby',
];

export const RADIUS_OPTIONS = [5, 10, 20, 50, 75, 100, 150, 200];
export const DEFAULT_RADIUS = 50;
export const MAX_RADIUS = 200;

export const MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

export const ALGOLIA = {
  appId: process.env.REACT_APP_ALGOLIA_APP_ID || '',
  searchKey: process.env.REACT_APP_ALGOLIA_SEARCH_API_KEY || '',
  index: process.env.REACT_APP_ALGOLIA_INDEX_LISTINGS || 'listings',
};

export const LOCATION_STORAGE_KEY = 'sosello.browseLocation';

export const REPORT_REASONS = [
  'Spam or scam',
  'Prohibited item',
  'Misleading or inaccurate',
  'Other',
];
